import { Box, Text } from "@aksara-ui/react";
import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import React from "react";
import { ReactComponent as Illustration } from "assets/images/illustrations-error-1.svg";

import { setTitle } from "utilities/helper/setTitle";

const NotFoundPage: React.FC = () => {
  setTitle("404");
  return (
    <Auth>
      <Layout>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"70vh"}
          style={{ gap: 25 }}
        >
          <Illustration />
          <Box
            display={"flex"}
            flexDirection={"column"}
            style={{ gap: 10 }}
            textAlign={"center"}
          >
            <Text fontWeight={800} fontSize={800}>
              404
            </Text>
            <Text fontWeight={600}>Page Not Found</Text>
          </Box>
        </Box>
      </Layout>
    </Auth>
  );
};

export default NotFoundPage;
